// extracted by mini-css-extract-plugin
export default {"image":"w2zVzYf1gYih3Cpagd4v","mobile":"M6UO7ISwII0762t35JI2","desktop":"pSxNarrVW6oDC8Di6FMe"};